
$controllers.dashboard = {

	refreshInterval : 60000,

	display : function($callback) {

		// display the dashboard view
		if (!$controllers.all.enforcePagePermissions('dashboard')) { return false; }
		$controllers.all.showPage('dashboard', 'homepage');
		$views.dashboard.showEmails();
		$views.dashboard.showTags();
		$views.dashboard.gettingStarted();
		$views.dashboard.display($callback);
		$controllers.all.setNavigation();

	},

	search : function() {

		var $keywords = jQuery('#mod-search-searchword').val();
		if ($keywords.length > 0) {
			$controllers.main.display({'filters[keywords]':$keywords});
		} else {
			$controllers.main.display();
		}

	},

	autoRefresh : function() {
		$controllers.dashboard.refreshTimer = setTimeout(function() {
			$views.dashboard.showEmails();
			$views.dashboard.showFolders();
			$controllers.dashboard.autoRefresh();
		}, $controllers.dashboard.refreshInterval);
	},

	toggleFavouriteFolder : function($folderid, $selector) {

		var $selector = '#folder-row-item-'+$folderid+' .favourite-icon' + ($selector ? ', '+$selector : '');

		jQuery($selector).addClass('favourite-icon-progress');

		if (!jQuery($selector).hasClass('favourite-icon-active')) {
			$models.favouriteFolders.setItem($folderid,
				function() {
					$views.dashboard.foldersGrid.changeItem($folderid, {favourited:true});
					$controllers.foldermanager.toggleHelpAreaFavouriteStatus();
				}, function() {
					jQuery($selector).removeClass('favourite-icon-progress');
				}
			);
		} else {
			$models.favouriteFolders.deleteItem($folderid, function() {
				$views.dashboard.foldersGrid.changeItem($folderid, {favourited:false});
				$controllers.foldermanager.toggleHelpAreaFavouriteStatus();
			});
		}

	}

};



// WEBPACK FOOTER //
// ./src/js/controllers/desktop.dashboard.js